import { actionable } from '@github/catalyst/lib/actionable'

export default actionable(class extends HTMLElement {
  connectedCallback () {
    this.template = this.querySelector('template[data-blueprint-row-template]')
    this.rowsEl = this.querySelector('[data-blueprint-rows]')
  }

  add () {
    const idx = this.querySelectorAll('[data-blueprint-row]').length
    const empty = this.rowsEl.querySelector('[data-blueprint-empty]')
    if (empty) empty.remove()

    const html = this.template.innerHTML.replaceAll('__IDX__', idx)
    const wrap = document.createElement('div')
    wrap.innerHTML = html.trim()
    const row = wrap.firstElementChild
    this.rowsEl.appendChild(row)
    row.querySelector('input[name*="[key]"]')?.focus()
  }

  remove (event) {
    const row = event.target.closest('[data-blueprint-row]')
    if (row) row.remove()
  }
})
